<template>
    <div class="wrapper">
        <div class="container">
            <el-card>
                <div class="header">
                    <el-steps :active="active" align-center>
                        <el-step title="提交材料" description="请填写需要提交的资料信息" :icon="active > 1 ? 'el-icon-circle-check' : ''">
                        </el-step>
                        <el-step title="后台审核" description="完成审核预计1~3个工作日，需耐心等待" :icon="active > 2 ? 'el-icon-circle-check' : ''">
                        </el-step>
                        <el-step title="审核通过" description="后台审核通过后可直接使用系统">
                        </el-step>
                    </el-steps>
                    <div class="titleFooter">
                        <span class="title">当前状态：</span>
                        <span v-for="item in statusList" :key="item.value">
                            <span v-if="item.value == status">{{ item.label }}</span>
                        </span>
                        <span v-if="status == 3" style="margin-left: 30px">
                            <span class="title">审核驳回原因：</span>
                            <span>{{ rejeactCause }}</span>
                        </span>
                    </div>
                </div>
            </el-card>
            <el-card style="margin-top: 20px">
                <div class="body">
                    <!-- active==1 提交材料 -->
                    <el-form ref="form" v-if="active == 1" :model="form" :rules="rules" label-width="400px">
                        <div class="title">
                            营业执照信息
                        </div>
                        <el-form-item ref="businessLicenseFile" label="上传营业执照" prop="businessLicenseFile">
                            <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'businessLicenseFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'businessLicenseFile');
                  }
                " :on-exceed="handleExceed" :file-list="fileList" accept=".jpg,.png">
                                <div class="imgBox">
                                    <div class="imgBody" v-if="!addrList.businessLicenseFileAddr">
                                        <i class="el-icon-plus"></i>
                                        上传照片
                                    </div>
                                    <!-- 上传照片 -->
                                    <div class="imgfooter" v-if="addrList.businessLicenseFileAddr">
                                        <img :src="yyzzUrl" alt="" width="100%" height="100%" />
                                        <!-- <i class="el-icon-plus"></i> -->
                                        <div class="imgTxt">
                                            重新上传
                                        </div>
                                    </div>
                                </div>
                                <div slot="tip" class="el-upload__tip">
                                    支持上传格式：JPG,
                                    PNG
                                </div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="企业名称" prop="customerName">
                            <el-input clearable v-model="form.customerName" placeholder="请输入企业名称">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="企业注册地址" prop="address">
                            <el-cascader style="width:24%;" placeholder="省份-城市" v-model="cityValue" :options="options" :props="{ expandTrigger: 'hover' }" @change="cityChange">
                            </el-cascader>
                            <el-input style="width:72%;margin-left:20px;" clearable v-model="form.address" placeholder="请输入企业注册地址">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="社会统一信用代码" prop="creditCode">
                            <!-- oninput="value=value.replace(/[^0-9A-Z]/g,'');" @blur="form.creditCode= $event.target.value" -->
                            <el-input clearable v-model="form.creditCode" placeholder="请输入社会统一信用代码">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="注册资本（万元）" prop="registerCapital">
                            <el-input-number clearable :controls="false" v-model="form.registerCapital" :min="0" :max="999999" placeholder="请输入注册资本">
                            </el-input-number>
                        </el-form-item>
                        <el-form-item label="成立日期" prop="registerDate">
                            <el-date-picker value-format="yyyy-MM-dd" v-model="form.registerDate" type="date" placeholder="请选择成立日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="营业期限" prop="registerDatetype">
                            <el-select clearable v-model="form.registerDatetype">
                                <el-option v-for="item in registerDateTypeList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="营业起始日期" prop="registerDateStart">
                            <el-date-picker size="small" style="width: 240px" v-model="form.registerDateStart" value-format="yyyy-MM-dd" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="营业截止日期" prop="registerDateEnd" v-if="form.registerDatetype == 2">
                            <el-date-picker size="small" style="width: 240px" v-model="form.registerDateEnd" value-format="yyyy-MM-dd" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-divider>
                        </el-divider>
                        <div class="title">
                            公司信息
                        </div>
                        <el-form-item label="选择公司性质" prop="companyType">
                            <el-select clearable v-model="form.companyType">
                                <el-option v-for="item in companyTypeList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="关联母公司名称" prop="mentorName" v-if="form.companyType == 2">
                            <el-select clearable v-model="form.mentorName">
                                <el-option v-for="item in customerList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item ref="mentorProveFile" label="关联母公司证明材料" prop="mentorProveFile" v-if="form.companyType == 2">
                            <el-upload style="width: 400px" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'mentorProveFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'mentorProveFile');
                  }
                " :on-exceed="handleExceed" :file-list="mentorProveFileFileList" accept=".doc,.docx,.pdf">
                                <el-button icon="el-icon-upload2">
                                    <!-- {{ addrList.mentorProveFileAddr ? "重新上传文件" : "上传文件"}} -->
                                    上传文件
                                </el-button>
                                <span class="txtStyle">支持扩展名：.doc
                                    .docx
                                    .pdf
                                    ...</span>
                            </el-upload>
                            <span class="hand" v-if="addrList.mentorProveFileAddr" @click="glmgsClick">关联母公司证明材料</span>
                        </el-form-item>
                        <el-divider>
                        </el-divider>
                        <div class="title">
                            企业账户信息
                        </div>
                        <el-form-item ref="accountOpeningFile" label="上传开户许可证" prop="accountOpeningFile">
                            <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'accountOpeningFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'accountOpeningFile');
                  }
                " :on-exceed="handleExceed" :file-list="accountOpeningFileList" accept=".jpg,.png">
                                <div class="imgBox">
                                    <div class="imgBody" v-if="!addrList.accountOpeningFileAddr">
                                        <i class="el-icon-plus"></i>
                                        上传照片
                                    </div>
                                    <div class="imgfooter" v-if="addrList.accountOpeningFileAddr">
                                        <img :src="khxkzUrl" alt="" width="100%" height="100%" />
                                        <div class="imgTxt">
                                            重新上传
                                        </div>
                                    </div>
                                </div>
                                <div slot="tip" class="el-upload__tip">
                                    支持上传格式：JPG,
                                    PNG
                                </div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="开户银行名称" prop="bankName">
                            <el-select @change="bankChange" placeholder="请输入" filterable remote :remote-method="remoteMethod" v-model="form.bankName" clearable :loading="loading">
                                <el-option v-for="(item,index) in bankList" :key="index" :label="item.label" :value="item.label">
                                </el-option>
                            </el-select>
                            <!-- <el-input clearable v-model="form.bankName" placeholder="请输入开户银行名称">
                            </el-input> -->
                        </el-form-item>
                        <el-form-item label="开户银行账号" prop="bankAccount">
                            <!-- <el-input-number clearable :controls="false" v-model="form.bankAccount" :min="0" placeholder="请输入开户银行账号">
                            </el-input-number> -->
                                <el-input v-model="form.bankAccount" @blur="form.bankAccount = $event.target.value" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
                        </el-form-item>
                        <el-divider>
                        </el-divider>
                        <div class="title">
                            法人及联系人信息
                        </div>
                        <el-form-item label="是否法人本人注册" prop="registerPersonFlag">
                            <el-radio-group v-model="form.registerPersonFlag" @change="radioChange">
                                <el-radio :label="1">
                                    是
                                </el-radio>
                                <el-radio :label="0">
                                    否
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item ref="corporaFile" label="上传法人身份证" prop="corporaFile">
                            <div class="imgWrapper">
                                <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="(file, fileList) => {handleRemove(file, fileList, 'corporaFile');}" :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'corporaFile');
                  }
                " :on-exceed="handleExceed" :file-list="corporaFileFileList" accept=".jpg,.png">
                                    <div class="imgBox">
                                        <div class="imgBody" v-if="!addrList.corporaFileAddress">
                                            <i class="el-icon-plus"></i>
                                            头像页
                                        </div>
                                        <div class="imgfooter" v-if="addrList.corporaFileAddress">
                                            <img :src="frsfzUrl" alt="" width="100%" height="100%" />
                                            <div class="imgTxt">
                                                重新上传
                                            </div>
                                        </div>
                                    </div>
                                </el-upload>
                                <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'idCarBFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'idCarBFile');
                  }
                " :on-exceed="handleExceed" :file-list="idCarBFileFileList" accept=".jpg,.png">
                                    <div class="imgBox" style="margin-left:20px">
                                        <div class="imgBody" v-if="!addrList.idCarBFileAddr">
                                            <i class="el-icon-plus"></i>
                                            国徽页
                                        </div>
                                        <div class="imgfooter" v-if="addrList.idCarBFileAddr">
                                            <img :src="frsfzfmUrl" alt="" width="100%" height="100%" />
                                            <div class="imgTxt">
                                                重新上传
                                            </div>
                                        </div>
                                    </div>
                                </el-upload>
                                <div slot="tip" class="el-upload__tip" style="margin-left:20px">
                                    照片信息清晰可见，内容真实有效，支持上传格式：JPG,
                                    PNG
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="法人姓名" prop="corporaName">
                            <el-input show-word-limit minlength="2" maxlength="4" clearable v-model="form.corporaName">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="法人身份证号码" prop="corporaIdNumber">
                            <el-input show-word-limit maxlength="18" clearable v-model="form.corporaIdNumber">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="法人手机号码" prop="corporaPhone">
                            <el-input :disabled="frDisabled" clearable v-model.number="form.corporaPhone">
                            </el-input>
                        </el-form-item>
                        <div v-if="form.registerPersonFlag === 0">

                            <el-form-item ref="contractFile" label="上传联系人身份证" prop="contractFile">
                                <div class="imgWrapper">
                                    <el-upload class="upload-demo" action :auto-upload="false" :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'contractFile');
                  }
                " :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'contractFile');
                  }
                " :on-exceed="handleExceed" :file-list="contractFileFileList" accept=".jpg,.png">
                                        <div class="imgBox">
                                            <div class="imgBody" v-if="!addrList.contractFileAddress">
                                                <i class="el-icon-plus"></i>
                                                上传照片
                                            </div>
                                            <div class="imgfooter" v-if="addrList.contractFileAddress">
                                                <img :src="lxrSfzUrl" alt="" width="100%" height="100%" />
                                                <div class="imgTxt">
                                                    重新上传
                                                </div>
                                            </div>
                                        </div>
                                    </el-upload>
                                    <el-upload class="upload-demo" action :auto-upload="false" :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'corporaIdCarBFile');
                  }
                " :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'corporaIdCarBFile');
                  }
                " :on-exceed="handleExceed" :file-list="corporaIdCarBFileList" accept=".jpg,.png">
                                        <div class="imgBox" style="margin-left:20px">
                                            <div class="imgBody" v-if="!addrList.corporaIdCarBFileAddr">
                                                <i class="el-icon-plus"></i>
                                                国徽页
                                            </div>
                                            <div class="imgfooter" v-if="addrList.corporaIdCarBFileAddr">
                                                <img :src="lxrSfzUrl" alt="" width="100%" height="100%" />
                                                <div class="imgTxt">
                                                    重新上传
                                                </div>
                                            </div>
                                        </div>

                                    </el-upload>
                                    <div slot="tip" class="el-upload__tip" style="margin-left:20px">
                                        照片信息清晰可见，内容真实有效，支持上传格式：JPG,
                                        PNG
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="联系人姓名" prop="contactName">
                                <el-input clearable v-model="form.contactName">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="联系人身份证号码" prop="contractIdNumber">
                                <el-input show-word-limit maxlength="18" clearable v-model="form.contractIdNumber">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="联系人手机号码" prop="contactPhone">
                                <el-input :disabled="lxrDisabled" clearable v-model.number="form.contactPhone">
                                </el-input>
                            </el-form-item>
                            <el-form-item ref="attorneyFile" label="上传法人授权委托书" prop="attorneyFile" v-if="
                form.contractIdNumber && form.corporaIdNumber
                  ? form.contractIdNumber.length > 17 &&
                    form.corporaIdNumber.length > 17 &&
                    form.contractIdNumber != form.corporaIdNumber
                  : false
              ">
                                <el-upload style="width: 400px" action :auto-upload="false" :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'attorneyFile');
                  }
                " :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'attorneyFile');
                  }
                " :on-exceed="handleExceed" :file-list="attorneyFileFileList">
                                    <!-- accept=".doc,.docx,.pdf,.jpg,.png" -->
                                    <el-button icon="el-icon-upload2">
                                        上传文件
                                    </el-button>
                                    <!-- <span class="txtStyle">支持扩展名：.doc
                                        .docx
                                        .pdf.jpg,.png...</span> -->
                                </el-upload>
                                <span class="hand" v-if="addrList.attorneyFileAddress" @click="frwtsClick">法人授权委托书</span>
                            </el-form-item>
                        </div>

                    </el-form>
                    <!-- active==2 后台审核 仅显示-->
                    <el-form ref="form" v-if="active == 2" :model="form" label-width="400px">
                        <div class="title">
                            营业执照信息
                        </div>
                        <el-form-item label="上传营业执照：" prop="businessLicenseFile">
                            <div class="imgBox">
                                <div class="imgfooter">
                                    <img :src="yyzzUrl" alt="" width="100%" height="100%" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="企业名称：" prop="customerName">
                            {{ form.customerName }}
                        </el-form-item>
                        <el-form-item label="企业注册地址：" prop="address">
                            {{ form.address }}
                        </el-form-item>
                        <el-form-item label="社会统一信用代码：" prop="creditCode">
                            {{ form.creditCode }}
                        </el-form-item>
                        <el-form-item label="注册资本（万元）：" prop="registerCapital">
                            {{ form.registerCapital }}
                        </el-form-item>
                        <el-form-item label="成立日期：" prop="registerDate">
                            {{ form.registerDate }}
                        </el-form-item>
                        <el-form-item label="营业开始日期：" prop="registerDateStart">
                            {{ form.registerDateStart }}
                        </el-form-item>
                        <el-form-item label="营业结束日期：" prop="registerDateEnd">
                            {{form.registerDateEnd?form.registerDateEnd:'长期'  }}
                        </el-form-item>
                        <el-divider>
                        </el-divider>
                        <div class="title">
                            公司信息
                        </div>
                        <el-form-item label="选择公司性质：" prop="companyType">
                            <span v-for="item in companyTypeList" :key="item.value">
                                <span v-if="item.value == form.companyType">{{
                  item.label
                }}</span>
                            </span>
                        </el-form-item>
                        <el-form-item v-if="form.companyType == 2" label="关联母公司名称：" prop="mentorName">
                            {{ form.mentorName | getMentorNameLabel(customerList) }}
                        </el-form-item>
                        <el-form-item v-if="form.companyType == 2" label="关联母公司证明材料：" prop="mentorProveFile">
                            <span class="hand" v-if="addrList.mentorProveFileAddr" @click="glmgsClick">关联母公司证明材料</span>
                            <span v-if="!addrList.mentorProveFileAddr">暂无数据</span>
                        </el-form-item>
                        <el-divider>
                        </el-divider>
                        <div class="title">
                            企业账户信息
                        </div>
                        <el-form-item label="上传开户许可证">
                            <div class="imgBox">
                                <div class="imgfooter">
                                    <img :src="khxkzUrl" alt="" width="100%" height="100%" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="开户银行名称" prop="bankName">
                            {{ form.bankName }}
                        </el-form-item>
                        <el-form-item label="开户银行账号" prop="bankAccount">
                            {{ form.bankAccount }}
                        </el-form-item>
                        <el-divider>
                        </el-divider>
                        <div class="title">
                            法人及联系人信息
                        </div>
                        <el-form-item label="是否法人本人注册" prop="registerPersonFlag">
                            <el-radio-group disabled v-model="form.registerPersonFlag">
                                <el-radio :label="1">
                                    是
                                </el-radio>
                                <el-radio :label="0">
                                    否
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="上传法人身份证：" prop="corporaFile">
                            <div class="imgBox">
                                <div class="imgfooter">
                                    <img :src="frsfzUrl" alt="" width="100%" height="100%" />
                                </div>
                            </div>
                            <div class="imgBox" style="margin-left:20px;">
                                <div class="imgfooter">
                                    <img :src="frsfzfmUrl" alt="" width="100%" height="100%" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="法人姓名：" prop="corporaName">
                            {{ form.corporaName }}
                        </el-form-item>
                        <el-form-item label="法人身份证号码：" prop="corporaIdNumber">
                            {{ form.corporaIdNumber }}
                        </el-form-item>
                        <el-form-item label="法人手机号码：" prop="corporaPhone">
                            {{ form.corporaPhone }}
                        </el-form-item>
                        <div v-if="form.registerPersonFlag === 0">

                            <el-form-item label="上传联系人身份证：" prop="contractFile">
                                <div class="imgBox">
                                    <div class="imgfooter">
                                        <img :src="lxrSfzUrl" alt="" width="100%" height="100%" />
                                    </div>
                                </div>
                                <div class="imgBox" style="margin-left:20px;">
                                    <div class="imgfooter">
                                        <img :src="lxrsfzfmUrl" alt="" width="100%" height="100%" />
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="联系人姓名：" prop="contactName">
                                {{ form.contactName }}
                            </el-form-item>
                            <el-form-item label="联系人身份证号码：" prop="contractIdNumber">
                                {{ form.contractIdNumber }}
                            </el-form-item>
                            <el-form-item label="联系人手机号码：" prop="contactPhone">
                                {{ form.contactPhone }}
                            </el-form-item>
                            <el-form-item v-if="form.contractIdNumber != form.corporaIdNumber" label="上传法人授权委托书" prop="attorneyFile">
                                <span class="hand" v-if="addrList.attorneyFileAddress" @click="frwtsClick">法人授权委托书</span>
                                <span v-if="!addrList.attorneyFileAddress">暂无数据</span>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </el-card>
        </div>
        <div class="fr">
            <el-button :disabled="status != 0 && status != 3" @click="save">
                保存
            </el-button>
            <el-button :disabled="status != 0 && status != 3" type="primary" @click="submit">
                提交材料
            </el-button>
        </div>
    </div>
</template>
<script>
import getMvcUrl from "../../utils/mvcUrlUtil.js";
import { formatDate } from "@/common/js/date.js";
import { mapActions } from "vuex";
import getCheckPhone from '@/common/js/checkPhone.js';
import { decrypt } from '@/api/util'
export default {
    data() {
        const validCorporaName = (rule, value, callback) => {
            console.log(value)
            if (!value) {
                return callback(new Error("请输入法人姓名"));
            } else if (value.length < 2 || value.length > 4) {
                return callback(new Error("请输入2-4个汉字"));
            } else {
                callback();
            }
        };
        // 手机号校验
        const checkPhone = getCheckPhone();
        
        const validIdCard = (rule, value, callback) => {
            let msr =
                /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
            if (!msr.test(value)) {
                callback(new Error("请输入正确的18位身份证号码"));
            } else {
                callback();
            }
        };
        const corporaFileValidate = (rule, value, callback) => {
            if (this.corporaFileFileList.length == "0" && !this.addrList.corporaFileAddress) {
                callback(new Error("请上传法人身份证头像页"));
            } else if (this.idCarBFileFileList.length == "0" && !this.addrList.idCarBFileAddr) {
                callback(new Error("请上传法人身份证国徽页"));
            } else {
                callback();
            }
        };
        const contractFileValidate = (rule, value, callback) => {
            if (this.contractFileFileList.length == "0" && !this.addrList.contractFileAddress) {
                callback(new Error("请上传联系人身份证"));
            } else if (this.corporaIdCarBFileList.length == "0" && !this.addrList.corporaIdCarBFileAddr) {
                callback(new Error("请上传联系人身份证国徽页"));
            } else {
                callback();
            }
        };
        var _this = this;
        const getRule = (FileList, addrItem, text) => {
            return (rule, _value, callback) => {
                if (_this[FileList].length == "0" && !this.addrList[addrItem]) {
                    return callback(new Error(text));
                } else {
                    callback();
                }
            }
        }
        return {
            fileArr: [
                { fileName: 'businessLicenseFile', listName: 'fileList' },
                { fileName: 'mentorProveFile', listName: 'mentorProveFileFileList' },
                { fileName: 'corporaFile', listName: 'corporaFileFileList', type: 'idCard' },
                { fileName: 'idCarBFile', listName: 'idCarBFileFileList', type: 'idCard' },
                { fileName: 'contractFile', listName: 'contractFileFileList', type: 'lxrCard' },
                { fileName: 'corporaIdCarBFile', listName: 'corporaIdCarBFileList', type: 'lxrCard' },
                { fileName: 'attorneyFile', listName: 'attorneyFileFileList' },
                { fileName: 'accountOpeningFile', listName: 'accountOpeningFileList' },
            ],
            formCopy: {},
            frDisabled: false,
            lxrDisabled: false,
            loading: null,
            bankList: [],
            cityValue: [],
            options: [],
            radio: 1,
            registerDatetype: 1,
            registerDateTypeList: [
                {
                    value: 1,
                    label: "长期",
                },
                {
                    value: 2,
                    label: "选择",
                },
            ],
            rejeactCause: "",
            fileBaseUrl: "",
            lxrSfzUrl: "",
            lxrsfzfmUrl: "",
            frsfzUrl: "",
            frsfzfmUrl: "",
            khxkzUrl: "",
            yyzzUrl: "",
            active: 1,
            customerList: [],
            companyTypeList: [
                {
                    value: 1,
                    label: "母公司",
                },
                {
                    value: 2,
                    label: "子公司",
                },
            ],
            state: this.$store.state.login.state,
            status: "",
            userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
            form: {
                customerNo: JSON.parse(sessionStorage.getItem("userInfo")).customerNo,
                customerName: "",
                address: "",
                creditCode: "",
                registerCapital: undefined,
                registerDate: "",
                registerDateStart: "",
                registerDateEnd: "",
                companyType: "",
                mentorName: "",
                corporaFile: "",
                corporaName: "",
                corporaIdNumber: "",
                corporaPhone: "",
                contractFile: "",
                contactName: "",
                contactPhone: "",
                contractIdNumber: "",
                provinceCode: "",
                cityCode: "",
                bankName: "",
                banka: "",
                bankAccount: '',
                registerPersonFlag: "",
                provinceName: "",
                cityName: "",
            },
            addrList: {
                businessLicenseFileAddr: "", //营业执照存储地址
                corporaFileAddress: "", //法人身份证件地址
                idCarBFileAddr: "", //法人身份证件反面
                contractFileAddress: "", //联系人身份证件地址
                corporaIdCarBFileAddr: "", //联系人身份证件反面地址
                attorneyFileAddress: "", //委托书存储地址
                mentorProveFileAddr: "", //母公司证明材料
                accountOpeningFileAddr: "", //开户许可证文件
            },
            fileList: [],
            mentorProveFileFileList: [],
            corporaFileFileList: [],
            idCarBFileFileList: [],
            contractFileFileList: [],
            corporaIdCarBFileList: [],
            attorneyFileFileList: [],
            accountOpeningFileList: [],
            rules: {
                businessLicenseFile: [
                    {
                        required: true,
                        validator: getRule('fileList', 'businessLicenseFileAddr', '请上传营业执照'),
                        trigger: "blur",
                    },
                ],
                customerName: [
                    { required: true, message: "请输入企业名称", trigger: "blur" },
                ],
                address: [
                    { required: true, message: "请输入企业注册地址", trigger: "blur" },
                ],
                creditCode: [
                    {
                        required: true,
                        message: "请输入社会统一信用代码",
                        trigger: "blur",
                    },
                ],
                registerCapital: [
                    {
                        required: true,
                        message: "请输入注册资本（万元）",
                        trigger: "blur",
                    },
                ],
                registerDate: [
                    { required: true, message: "请选择成立日期", trigger: "change" },
                ],
                registerDatetype: [
                    { required: true, message: "请选择营业期限", trigger: "change" },
                ],
                registerDateStart: [
                    { required: true, message: "请选择营业起始日期", trigger: "change" },
                ],
                registerDateEnd: [
                    { required: true, message: "请选择营业截止日期", trigger: "change" },
                ],
                companyType: [
                    { required: true, message: "请选择公司性质", trigger: "change" },
                ],
                mentorName: [
                    {
                        required: true,
                        message: "请选择关联母公司名称",
                        trigger: "change",
                    },
                ],
                mentorProveFile: [
                    {
                        required: true,
                        validator: getRule('mentorProveFileFileList', 'mentorProveFileAddr', '请上传关联母公司证明材料'),
                        trigger: "change",
                    },
                ],
                corporaFile: [
                    { required: true, validator: corporaFileValidate, trigger: "change" },
                ],
                corporaName: [
                    { required: true, validator: validCorporaName, trigger: "blur" },
                ],
                corporaIdNumber: [
                    { required: true, validator: validIdCard, trigger: "blur" },
                ],
                corporaPhone: [
                    { required: true, validator: checkPhone, trigger: "blur" },
                ],
                contractFile: [
                    {
                        required: true,
                        validator: contractFileValidate,
                        trigger: "change",
                    },
                ],
                contactName: [
                    { required: true, message: "请输入联系人姓名", trigger: "blur" },
                ],
                contractIdNumber: [
                    { required: true, validator: validIdCard, trigger: "blur" },
                ],
                contactPhone: [
                    { required: true, validator: checkPhone, trigger: "blur" },
                ],
                attorneyFile: [
                    {
                        required: true,
                        validator: getRule('attorneyFileFileList', 'attorneyFileAddress', '请上传法人授权委托书'),
                        trigger: "change",
                    },
                ],
                accountOpeningFile: [
                    {
                        required: true,
                        validator: getRule('accountOpeningFileList', 'accountOpeningFileAddr', '请上传开户许可证'),
                        trigger: "change",
                    },
                ],
                bankName: [
                    { required: true, message: "请输入开户银行名称", trigger: "blur" },
                ],
                bankAccount: [
                    { required: true, message: "请输入开户银行账号", trigger: "blur" },
                ],
                registerPersonFlag: [
                    { required: true, message: "请选择是否法人本人注册", trigger: "change" },
                ],
            },
            formData: "",
            statusList: [
                { value: 0, label: "未提交" },
                { value: 1, label: "提交资料" },
                { value: 2, label: "审核通过" },
                { value: 3, label: "审核驳回" },
                { value: 4, label: "失效" },
            ],
        };
    },
    mounted() {
        this.initCity();
        this.getAllCustomer();
        this.formData = new window.FormData();
    },
    filters: {
        getMentorNameLabel(val, customerList) {
            return customerList.find((item) => {
                return item.value == val;
            }).label;
        },
    },
    methods: {
        ...mapActions([
            "queryByCustomerNoAPI",
            "submitDraft",
            "submitVerify",
            "queryAllMentorConpany",
            "listAllCitys",
            "queryBankAccountApi",
        ]),
        radioChange(val) {
            if (val === 1) {
                this.frDisabled = true;
                this.lxrDisabled = false;
                this.form.corporaPhone = this.userInfo.telephone;
                this.form.contactName = this.formCopy.contactName;
                this.form.contractIdNumber = this.formCopy.contractIdNumber;
                this.form.contactPhone = this.formCopy.contactPhone;
            }
            if (val === 0) {
                this.form.contactPhone = this.userInfo.telephone;
                this.lxrDisabled = true;
                this.frDisabled = false;
            }
        },
        bankChange(val) {
            console.log(val)

        },
        remoteMethod(val) {
            console.log(val)
            if (val !== '') {
                this.loading = true;
                this.queryBankAccountApi({ bankName: val })
                    .then(res => {
                        if (res) {
                            console.log(res)
                            let result = res.bankList
                            console.log(result);
                            result = result.map(item => {
                                return {
                                    value: item.bankl,
                                    label: item.banka,
                                }
                            })
                            this.bankList = result.filter(item => {
                                return item.label.toLowerCase()
                                    .indexOf(val.toLowerCase()) > -1;
                            });
                            console.log(this.bankList);
                            this.loading = false;
                        }
                    })
            } else {
                this.bankList = [];
            }
        },
        cityChange(val) {
            console.log(val)
            if (val.length > 0) {
                this.form.provinceCode = val[0];
                this.form.cityCode = val[1];
                let cityList = [];
                this.options.forEach(item => {
                    cityList.push(item.children)
                    item.children.forEach(el => {
                        cityList.push(el)
                    })
                })
                let cityObj = cityList.find(item => {
                    return item.value == this.form.cityCode
                })
                let provinceObj = this.options.find(item => {
                    return item.value == this.form.provinceCode
                })
                this.form.provinceName = provinceObj.label;
                this.form.cityName = cityObj.label;
            }
        },
        glmgsClick() {
            let path = this.fileBaseUrl + this.addrList.mentorProveFileAddr;
            window.open(encodeURI(path), "_self");
        },
        frwtsClick() {
            let { attorneyFileAddress } = this.addrList
            let url;
            if (attorneyFileAddress && (attorneyFileAddress.indexOf('.jpg') != '-1' || (attorneyFileAddress.indexOf('.png') != '-1'))) {
                url = this.imgBaseUrl;
            } else {
                url = this.fileBaseUrl;
            }
            let path = url + this.addrList.attorneyFileAddress;
            window.open(encodeURI(path), "_self");
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        save() {
            // 保存  提交草稿
            let params = this.getParams();
            this.formData.delete("param");
            this.formData.append("param", JSON.stringify(params));
            console.log(params)
            this.submitDraft(this.formData).then((res) => {
                if (res) {
                    console.log(res);
                    this.$message.success("操作成功");
                }
            });
        },
        submit() {
            //提交审核
            let params = this.getParams();
            this.formData.delete("param");
            this.formData.append("param", JSON.stringify(params));
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitVerify(this.formData).then((res) => {
                        console.log(res);
                        if (res) {
                            this.$message.success("操作成功");
                            this.active = 2;
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        queryByCustomerNo() {
            // 进入页面回显相关信息
            let params = {
                customerNo: this.form.customerNo,
            };
            this.queryByCustomerNoAPI(params).then(async(res) => {
                let { customerDetail, historyList } = res;
                this.rejeactCause = historyList[0].updateResult;
                this.status = customerDetail.status;
                const decryptProps = []
                for (let key in this.form) {
                    if (key != "yyqx") {
                        this.form[key] = customerDetail[key] || '';
                        if (customerDetail[`${key}Dto`]) {
                            decryptProps.push(`${key}`)
                        }
                    }
                }
                if (customerDetail.mentorName) {
                    let obj = this.customerList.find((item) => {
                        return item.label == customerDetail.mentorName;
                    });
                    this.form.mentorName = obj.value;
                }
                for (let key in this.addrList) {
                    this.addrList[key] = customerDetail[key];
                    this.form[key] = customerDetail[key] || '';
                    if (customerDetail[`${key}Dto`]) {
                        decryptProps.push(`${key}`)
                    }
                }
                
                if (this.form.registerPersonFlag === '0' || this.form.registerPersonFlag === '1') {
                    this.form.registerPersonFlag = + this.form.registerPersonFlag;
                }
                
                this.fileBaseUrl =
                    getMvcUrl() + "/saas/companyQualification/downLoadFile?objectName=";
                let imgBaseUrl =
                    getMvcUrl() + "/saas/companyQualification/viewImage?objectName=";
                this.imgBaseUrl = imgBaseUrl;
                this.yyzzUrl = imgBaseUrl + this.addrList.businessLicenseFileAddr;
                this.frsfzUrl = imgBaseUrl + this.addrList.corporaFileAddress;
                this.frsfzfmUrl = imgBaseUrl + this.addrList.idCarBFileAddr;
                this.khxkzUrl = imgBaseUrl + this.addrList.accountOpeningFileAddr;
                this.lxrSfzUrl = imgBaseUrl + this.addrList.contractFileAddress;
                this.lxrsfzfmUrl = imgBaseUrl + this.addrList.corporaIdCarBFileAddr;
                switch (this.status) {
                    case 1:
                        this.active = 2;
                        break;
                    case 2:
                        this.active = 3;
                        break;
                    default:
                        this.active = 1;
                        break;
                }
                if (this.form.registerDate) {
                    this.form.registerDate = formatDate(
                        new Date(this.form.registerDateStart),
                        "yyyy-MM-dd"
                    );
                }
                if (this.form.registerDateStart) {
                    this.form.registerDateStart = formatDate(
                        new Date(this.form.registerDateStart),
                        "yyyy-MM-dd"
                    );
                }
                if (this.form.registerDateEnd) {
                    this.form.registerDateEnd = formatDate(
                        new Date(this.form.registerDateEnd),
                        "yyyy-MM-dd"
                    );
                }
                if (this.form.registerPersonFlag === 1) {
                    this.form.corporaPhone = this.userInfo.telephone;
                    this.frDisabled = true;
                }
                if (this.form.registerPersonFlag === 0) {
                    this.form.contactPhone = this.userInfo.telephone;
                    this.lxrDisabled = true;
                }
                this.cityValue = [this.form.provinceCode, this.form.cityCode];
                this.setCityAttr();
                // 解密
                if (decryptProps.length > 0) {
                const decryptAll = () => {
                    return new Promise((resolve, reject) => {
                    decryptProps.forEach( async(prop, index) => {
                        const decryptValue = await decrypt(customerDetail[`${prop}Dto`].encStr)
                        this.form[prop] = decryptValue
                        if (index === decryptProps.length -1) {
                        resolve(true)
                        }
                    })
                    }) 
                }
                await decryptAll()
                }
                this.formCopy = JSON.parse(JSON.stringify(this.form))
            });
        },
        setCityAttr() {
            let cityList = [];
            this.options.forEach(item => {
                cityList.push(item.children)
                item.children.forEach(el => {
                    cityList.push(el)
                })
            })
            console.log(cityList)
            let cityObj = cityList.find(item => {
                return item.value == this.form.cityCode
            })
            let provinceObj = this.options.find(item => {
                return item.value == this.form.provinceCode
            })
            if (provinceObj && cityObj)
                this.form.address = provinceObj.label + cityObj.label + this.form.address
        },
        initCity() {
            this.listAllCitys({}).then(res => {
                let { obj } = res
                let arr = obj.map(item => {
                    return {
                        value: item.code,
                        label: item.name,
                        children: item.cityList.map(el => {
                            return {
                                value: el.code,
                                label: el.name,
                            }
                        })
                    }
                })
                this.options = arr;
            })
        },
        getAllCustomer() {
            this.queryAllMentorConpany({}).then(
                (res) => {
                    if (res) {
                        this.customerList = res.customers.map((item) => {
                            return {
                                value: item.customerNo,
                                label: item.customerName,
                            };
                        });
                        this.queryByCustomerNo(); // 查询货主信息
                    }
                },
                (res) => {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            );
        },
        getParams() {
            let obj = this.bankList.find(item => {
                return item.label === this.form.bankName;
            })
            if (obj && Object.keys(obj).length > 0) {
                this.form.banka = obj.value;
            }
            let params = JSON.parse(JSON.stringify(this.form));
            if (this.form.registerDatetype == 1) {
                params.registerDateEnd = null;
            }
            params.contractIdNumber =params.contractIdNumber?params.contractIdNumber.toUpperCase():null;
            params.corporaIdNumber =params.corporaIdNumber?params.corporaIdNumber.toUpperCase():null;
            return params;
        },

        handleRemove(file, fileList, val) {
            this.fileArr.forEach(item => {
                if (item.fileName == val) {
                    this[item.listName] = [];
                    this.formData.delete(item.fileName)
                }
            })
            // switch (val) {
            //     case "businessLicenseFile":
            //         // 文件移除时清空显示 清空formData之前append的文件
            //         this.fileList = [];
            //         this.formData.delete("businessLicenseFile");
            //         break;
            //     case "mentorProveFile":
            //         this.mentorProveFileFileList = [];
            //         this.formData.delete("mentorProveFile");
            //         break;
            //     case "corporaFile":
            //         this.corporaFileFileList = [];
            //         this.formData.delete("corporaFile");
            //         break;
            //     case "idCarBFile":
            //         this.idCarBFileFileList = [];
            //         this.formData.delete("idCarBFile");
            //         break;
            //     case "contractFile":
            //         this.contractFileFileList = [];
            //         this.formData.delete("contractFile");
            //         break;
            //     case "contractFile":
            //         this.corporaIdCarBFileList = [];
            //         this.formData.delete("corporaIdCarBFile");
            //         break;
            //     case "attorneyFile":
            //         this.attorneyFileFileList = [];
            //         this.formData.delete("attorneyFile");
            //         break;
            //     case "accountOpeningFile":
            //         this.accountOpeningFileList = [];
            //         this.formData.delete("accountOpeningFile");
            //         break;
            //     default:
            //         break;
            // }
        },
        handleChange(file, fileList, val) {
            let size = Number(file.size / 1024 / 1024);
            let pass;
            console.log(size)
            if (size > 5) {
                this.$message.warning('文件大小不能超过5MB，请重新上传');
                pass = false;
            } else {
                pass = true;
            }
            this.fileArr.forEach(item => {
                if (item.fileName == val) {
                    this[item.listName] = [];
                    if (pass) {
                        this[item.listName] = [];
                        this[item.listName].push(file);
                    } else {
                        this.formData.delete(item.fileName);
                    }
                    this.formData.delete(item.fileName);
                    this.formData.append(item.fileName, file.raw);
                    if (item.type == 'idCard') {
                        this.$refs.corporaFile.clearValidate();
                    } else if (item.type == 'lxrCard') {
                        this.$refs.contractFile.clearValidate();
                    } else {
                        this.$refs[item.fileName].clearValidate();
                    }
                }
            })
            // switch (val) {
            //     case "businessLicenseFile":
            //         // 清空 fileList 清空formData对象上次上传结果  清除当前表单校验
            //         this.fileList = [];
            //         if (pass) {
            //             this.fileList.push(file);
            //         } else {
            //             this.formData.delete("businessLicenseFile");
            //             return
            //         }
            //         this.formData.delete("businessLicenseFile");
            //         this.formData.append("businessLicenseFile", file.raw);
            //         this.$refs["businessLicenseFile"].clearValidate();
            //         break;
            //     case "mentorProveFile":
            //         this.mentorProveFileFileList = [];
            //         if (pass) {
            //             this.mentorProveFileFileList.push(file);
            //         } else {
            //             this.formData.delete("mentorProveFile");
            //             return
            //         }
            //         this.formData.delete("mentorProveFile");
            //         this.formData.append("mentorProveFile", file.raw);
            //         this.$refs["mentorProveFile"].clearValidate();
            //         break;
            //     case "corporaFile":
            //         this.corporaFileFileList = [];
            //         if (pass) {
            //             this.corporaFileFileList.push(file);
            //         } else {
            //             this.formData.delete("corporaFile");
            //             return
            //         }
            //         this.formData.delete("corporaFile");
            //         this.formData.append("corporaFile", file.raw);
            //         this.$refs["corporaFile"].clearValidate();
            //         break;
            //     case "idCarBFile":
            //         this.idCarBFileFileList = [];
            //         if (pass) {
            //             this.idCarBFileFileList.push(file);
            //         } else {
            //             this.formData.delete("idCarBFile");
            //             return
            //         }
            //         this.formData.delete("idCarBFile");
            //         this.formData.append("idCarBFile", file.raw);
            //         break;
            //     case "contractFile":
            //         this.contractFileFileList = [];
            //         if (pass) {
            //             this.contractFileFileList.push(file);
            //         } else {
            //             this.formData.delete("contractFile");
            //             return
            //         }
            //         this.formData.delete("contractFile");
            //         this.formData.append("contractFile", file.raw);
            //         this.$refs["contractFile"].clearValidate();
            //         break;
            //     case "corporaIdCarBFile":
            //         this.corporaIdCarBFileList = [];
            //         if (pass) {
            //             this.corporaIdCarBFileList.push(file);
            //         } else {
            //             this.formData.delete("corporaIdCarBFile");
            //             return
            //         }
            //         this.formData.delete("corporaIdCarBFile");
            //         this.formData.append("corporaIdCarBFile", file.raw);
            //         this.$refs["contractFile"].clearValidate();
            //         break;
            //     case "attorneyFile":
            //         this.attorneyFileFileList = [];
            //         if (pass) {
            //             this.attorneyFileFileList.push(file);
            //         } else {
            //             this.formData.delete("attorneyFile");
            //             return
            //         }
            //         this.formData.delete("attorneyFile");
            //         this.formData.append("attorneyFile", file.raw);
            //         this.$refs["attorneyFile"].clearValidate();
            //         break;
            //     case "accountOpeningFile":
            //         this.accountOpeningFileList = [];
            //         if (pass) {
            //             this.accountOpeningFileList.push(file);
            //         } else {
            //             this.formData.delete("accountOpeningFile");
            //             return
            //         }
            //         this.formData.delete("accountOpeningFile");
            //         this.formData.append("accountOpeningFile", file.raw);
            //         this.$refs["accountOpeningFile"].clearValidate();
            //         break;
            //     default:
            //         break;
            // }
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) { },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
    },
};
</script>
<style lang="less" scoped>
/deep/ .el-step__title.is-finish {
    color: #000;
    font-weight: 700;
}
/deep/ .el-step__title.is-process {
    color: #c0c4cc;
    font-weight: 700;
}
/deep/ .el-step__description {
    color: rgba(0, 0, 0, 0.65);
}
/deep/ .el-form-item__content {
    width: 600px !important;
}
/deep/ .el-form-item {
    margin-bottom: 22px !important;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner,
.el-select,
/deep/ .el-input-number {
    width: 100% !important;
}
/deep/ .el-input__inner {
    text-align: left !important;
}
/deep/ .el-date-editor .el-range__icon {
    margin-left: 4px;
}
.wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    .container {
        padding: 10px;
        overflow: hidden;
        background-color: #f1f1f1 !important;
        .header {
            padding: 30px 300px !important;
        }
        .body {
            .title {
                font-family: PingFangSC-Medium;
                padding: 20px !important;
                font-weight: 700;
            }
            .imgWrapper {
                display: flex;
                // align-items: center;
            }
            .imgBox {
                width: 100px;
                height: 100px;
                border: 1px dotted #ddd;
                background-color: #f6f6f6;
                position: relative;
                display: inline-block;
                .imgBody {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
                .imgfooter {
                    width: 100%;
                    height: 100%;
                    background-color: #f5f5f5;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .imgTxt {
                        position: absolute;
                        height: 30px;
                        line-height: 30px;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        text-align: center;
                        background: rgba(0, 0, 0, 0.5);
                        color: #fff;
                    }
                }
            }
        }
    }
    .fr {
        margin-top: 20px !important;
        padding: 10px !important;
        width: 100%;
        height: 60px;
        background-color: #fff;
        display: flex;
        justify-content: flex-end;
    }
}
// a {
//   color: #dc1e32 !important;
//   text-decoration: none;
// }
.hand {
    color: #dc1e32 !important;
    cursor: pointer;
}
.titleFooter {
    font-size: 15px !important;
    margin: 20px 0 0px 100px !important;
    .title {
        font-weight: bold !important;
    }
}
.txtStyle {
    margin-left: 10px !important;
}
/deep/ .el-upload-list__item-name {
    width: 98px;
    margin-right: 0 !important;
}
</style>